import formatNumber from '@/utils/NumberFormatter';
import Validatable from '@/validator/Validatable';

export interface IRevenueSplitItemAPI {
  uniqueadvertiser_id: number;
  uniqueadvertiser_name: string;
  account_id: number;
  account_name: string;
  buyer_id: number;
  buyer_name: string;
  revenue: number;
}

export default class RevenueSplitItem extends Validatable {
  name: string;
  revenue: number;
  type: string;

  constructor(id, name, revenue, type) {
    super();
    this.id = id;
    this.name = name;
    this.revenue = revenue;
    this.type = type;
  }

  get revenueFormatted() {
    return `${Math.round(this.revenue)}`.length % 3 === 0
      ? formatNumber(this.revenue, '$0a')
      : formatNumber(this.revenue, '$0.0a');
  }

  static fromApi(apiObject: IRevenueSplitItemAPI) {
    if (apiObject.uniqueadvertiser_id !== undefined) {
      return new RevenueSplitItem(
        apiObject.uniqueadvertiser_id,
        apiObject.uniqueadvertiser_name,
        apiObject.revenue,
        'UniqueAdvertiser',
      );
    }
    if (apiObject.account_id !== undefined) {
      return new RevenueSplitItem(apiObject.account_id, apiObject.account_name, apiObject.revenue, 'Account');
    }
    if (apiObject.buyer_id !== undefined) {
      return new RevenueSplitItem(apiObject.buyer_id, apiObject.buyer_name, apiObject.revenue, 'Buyer');
    }
    return null;
  }
}
